// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as HexagonBDefault } from '../../../assets/icons/default/shapes/hexagon-b.svg?react';
import { ReactComponent as HexagonBSolid } from '../../../assets/icons/solid/shapes/HEXAGON-B.svg?react';
import { createIcons } from '../../Icon';
const HexagonBIcon = /* @__PURE__ */ createIcons('HexagonB', {
    default: HexagonBDefault,
    solid: HexagonBSolid
});
HexagonBIcon.supportedTypes = ['default', 'solid'];
HexagonBIcon.category = 'shapes';
export default HexagonBIcon;
